
import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ApiService } from '../../../../../shared/services/api.service';
import { CommonService } from '../../../../../shared/services/common.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';

@Component({
  selector: 'app-update-document-history-popup',
  templateUrl: './update-document-history-popup.component.html',
  styleUrl: './update-document-history-popup.component.css'
})

export class UpdateDocumentHistoryPopupComponent implements OnInit {
  dataSource: any[] = [];
  totalRecords: number = 0;
  EventId: string = '—';

  pagination = {
    pageNumber: 1,
    pageSize: 10,
    searchTerm: '',
    sortColumn: 'CreatedOn',
    sortDirection: 'DESC',
    UniqueEventId: ''
  };

  searchTimeout: any;

  constructor(
    private apiService: ApiService,
    private dialogRef: MatDialogRef<UpdateDocumentHistoryPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    console.log('Document History Popup Received:', this.data);

    // १. आधीच्या स्क्रीनवरून आलेला चालू इव्हेंटचा अचूक आयडी मॅप करणे
    this.pagination.UniqueEventId = this.data.UniqueEventId || this.data.uniqueEventId || '';
    this.EventId = this.data.EventId || this.data.EventCode || '—';

    this.loadData();
  }

  closeDialog() {
    this.dialogRef.close();
  }

  loadData() {
    if (!this.pagination.UniqueEventId) {
      console.warn('Cannot load history because UniqueEventId is missing.');
      return;
    }

    // 🟢 आपण बॅकएंडला इथून सांगतोय की हा ऑडिट ट्रेलचा कॉल आहे (&isAuditTrail=true)
   /* const urlWithParams = `${API_ENDPOINTS.IA.GETIAEVENTDOCUMENTSLIST}?UniqueEventId=${this.pagination.UniqueEventId}&isAuditTrail=true`;*/
    const urlWithParams = `${API_ENDPOINTS.IA.GETIAEVENTDOCUMENTSLIST}?UniqueEventId=${this.pagination.UniqueEventId}&isAuditTrail=true&PageNumber=${this.pagination.pageNumber}&PageSize=${this.pagination.pageSize}&SearchTerm=${this.pagination.searchTerm}`;
    console.log('Hitting Document History API with URL:', urlWithParams);

    this.apiService
      .getRequest(urlWithParams, this.pagination)
      .subscribe({
        next: (res: any) => {
          console.log('Raw API Response for History Popup:', res);

          if (res && (res.status || res.Status)) {
            // 🟢 मुख्य फिक्स: फ्रंट-एंडवरून कोणताही अतिरिक्त फिल्टर न लावता बॅकएंडचा सर्व डेटा थेट वापरणे
            this.dataSource = res.data || res.Data || [];


            console.log('Final Data bound to Audit Trail Table:', this.dataSource);
            this.totalRecords = res.totalRecords || res.TotalRecords || res.recordsFiltered || this.dataSource.length;
          } else {
            this.dataSource = [];
            this.totalRecords = 0;
          }
        },
        error: (err) => {
          console.error('Error fetching document history:', err);
          this.dataSource = [];
          this.totalRecords = 0;
        },
      });
  }

  onPageChange(event: any) {
    // 🟢 नेक्स्ट आणि प्रिव्हिअस बटण दाबल्यावर हे पेज व्हॅल्यू अपडेट करेल
    this.pagination.pageNumber = event.pageIndex + 1;
    this.pagination.pageSize = event.pageSize;
    this.loadData();
  }

  onSearchChange(value: string) {
    clearTimeout(this.searchTimeout);
    this.searchTimeout = setTimeout(() => {
      this.pagination.searchTerm = value;
      this.pagination.pageNumber = 1;
      this.loadData();
    }, 500);
  }

  downloadFile(row: any) {
    const filePath = row.FilePath || row.filePath || row.relativePath;
    if (!filePath) return;

    this.apiService.downloadFile(filePath).subscribe({
      next: (blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = row.DocumentName || 'Attachment';
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      }
    });
  }
}
